import React from 'react';
import { useSelector } from 'react-redux';
import {
  Avatar,
  Modal,
  useFileUpload,
  ImageCropper,
  Input,
  Button,
} from '../../../../components';
import { RootState } from '../../../../store/store';
import { useForm } from '../../hooks/useForm';
import { email, org, user, photo } from '../../icons';
import { InviteSuccessModal } from '../InviteSuccessModal/InviteSuccessModal';

type AddUserProps = {
  open: boolean;
  onClose: () => void;
};

export const AddUser: React.FC<AddUserProps> = ({
  open,
  onClose,
}: AddUserProps): JSX.Element => {
  const {
    croppedImage,
    file,
    handleUpload,
    removeFile,
    saveCroppedImage,
  } = useFileUpload();
  const {
    errors,
    handleChange,
    handleSubmit,
    values,
    closeModal,
    inviteSuccess,
    touched,
    handleCancel,
  } = useForm(onClose, croppedImage);
  const { org: organization } = useSelector((state: RootState) => state.auth);
  const {
    errors: { addUser: addUserError },
  } = useSelector((state: RootState) => state.users);

  return (
    <>
      <Modal open={!!file} onClose={removeFile} title="Upload a photo">
        <ImageCropper
          onSave={saveCroppedImage}
          onCancel={removeFile}
          image={file || ''}
        />
      </Modal>
      <InviteSuccessModal open={inviteSuccess} onClose={closeModal} />
      <div className={`add-user add-user-${open ? 'open' : 'closed'}`}>
        <h3 className="add-user__title">Add a new user</h3>
        <Avatar
          className="add-user__avatar"
          onUpload={handleUpload}
          image={croppedImage || photo}
          hasUpload
          style={{ width: '5rem', height: '5rem' }}
        />
        <form onSubmit={handleSubmit}>
          <Input
            error={touched.firstName ? errors.firstName : ''}
            onChange={handleChange}
            value={values.firstName}
            name="firstName"
            icon={user}
            className="add-user__input"
            label="First name"
          />
          <Input
            error={touched.lastName ? errors.lastName : ''}
            onChange={handleChange}
            value={values.lastName}
            name="lastName"
            icon={user}
            className="add-user__input"
            label="Last name"
          />
          <Input
            error={
              addUserError || (touched.primaryEmail ? errors.primaryEmail : '')
            }
            onChange={handleChange}
            value={values.primaryEmail}
            name="primaryEmail"
            icon={email}
            className="add-user__input"
            label="Primary email"
          />
          <Input
            onChange={handleChange}
            value={organization?.name}
            name="organizationalUnit"
            icon={org}
            className="add-user__input"
            label="Organizational unit"
            disabled
          />
          <Input
            error={touched.phoneNumber ? errors.phoneNumber : ''}
            onChange={handleChange}
            value={values.phoneNumber}
            name="phoneNumber"
            icon={email}
            className="add-user__input"
            label="Phone number (optional)"
          />
          <Button type="submit" className="add-user__btn" variant="common">
            Send invite
          </Button>
          <Button
            className="add-user__btn"
            onClick={handleCancel}
            variant="text"
          >
            Cancel
          </Button>
        </form>
      </div>
    </>
  );
};
